/**
 * DNI validator for Spain registration number
 *
 * Translated from Java (tech-starters/validation/src/main/java/com/hopwork/validation/registration/number/DniValidator.java)
 */
export function dniValidator(value: string): boolean {
    const CHECK_LETTER_TABLE = ['T', 'R', 'W', 'A', 'G', 'M', 'Y', 'F', 'P', 'D', 'X', 'B', 'N', 'J', 'Z', 'S', 'Q', 'V', 'H', 'L', 'C', 'K', 'E'];

    const cleanDni = value.replace(/ /g, '');
    if (cleanDni.length !== 9) {
        return false;
    }
    const pattern = /(\d+)/;
    const matcher = pattern.exec(cleanDni);
    if (matcher) {
        const dniNumber = parseInt(matcher[0]);
        const remainder = dniNumber % 23;
        const lastLetter = value[value.length - 1];
        return lastLetter?.toLowerCase() === CHECK_LETTER_TABLE[remainder]?.toLowerCase();
    }
    return false;
}
